import { useNavigate } from "react-router-dom";
import "../styles/notfound.css";
import { ArrowBack } from "@mui/icons-material";
import { useProjectTracker } from "../useProjectTracker";

export function NotFound() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    useProjectTracker();

    return (
        <div className="not-found">
            <div className="width-base">
                <div className="not-found-title">
                    404
                </div>
                <div className="not-found-text">
                    Sorry, this page could not be found.
                </div>
                <div className="not-found-link" onClick={handleGoBack} style={{ cursor: 'pointer' }}>
                    <ArrowBack /> <p>Go back</p>
                </div>
            </div>
        </div>
    );
}